var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustpilotRatings4StarRgb = function SvgTrustpilotRatings4StarRgb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 18,
    viewBox: "0 0 90 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_4star-RGB_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.16.023H17v16.801H.16Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_4star-RGB_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 .023h18v16.801H18Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_4star-RGB_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 .023h18v16.801H36Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_4star-RGB_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 .023h18v16.801H54Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_4star-RGB_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 .023h17.762v16.801H72Zm0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_4star-RGB_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M16.96.023H.16v16.801h16.8Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_4star-RGB_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M35.16.023h-16.8v16.801h16.8Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_4star-RGB_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M53.36.023H36.562v16.801h16.796Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_4star-RGB_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M71.563.023H54.761v16.801h16.8Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_4star-RGB_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#dcdce6",
      fillOpacity: 1
    },
    d: "M89.762.023H72.96v16.801h16.8Zm0 0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "m8.563 11.348 2.554-.649 1.067 3.29Zm5.878-4.254h-4.5L8.562 2.859 7.18 7.094h-4.5l3.64 2.625-1.383 4.234 3.641-2.625 2.238-1.61ZM26.762 11.348l2.554-.649 1.067 3.29Zm5.879-4.254h-4.496l-1.383-4.235-1.383 4.235h-4.5l3.64 2.625-1.382 4.234 3.64-2.625 2.243-1.61ZM44.96 11.348l2.556-.649 1.066 3.29Zm5.88-4.254h-4.496L44.96 2.859l-1.383 4.235h-4.496l3.64 2.625-1.382 4.234 3.637-2.625 2.242-1.61ZM63.16 11.348l2.555-.649 1.07 3.29Zm5.88-4.254h-4.497L63.16 2.859l-1.383 4.235h-4.496l3.64 2.625-1.382 4.234 3.64-2.625 2.239-1.61ZM81.36 11.348l2.554-.649 1.07 3.29Zm5.882-4.254h-4.5L81.36 2.859l-1.382 4.235H75.48l3.641 2.625-1.383 4.234 3.64-2.625 2.24-1.61Zm0 0"
  }));
};
export default SvgTrustpilotRatings4StarRgb;